export const DEBOUNCE_DELAY_DEFAULT = 300
export const INACTIVE_BAR_BACKGROUND_COLOR = '#bebaba30'
